import React from "react";

export default function ReturnInformationTable({ data }) {
  const table = {
    header: [
      {
        id: 1,
        title: "반품요청",
      },
      {
        id: 2,
        title: (
          <span>
            반품거부
            <br />
            (구매확정)
          </span>
        ),
      },
      {
        id: 3,
        title: (
          <span>
            반품완료
            <br />
            (신용카드)
          </span>
        ),
      },
      {
        id: 4,
        title: (
          <span>
            반품완료
            <br />
            (무통장입금)
          </span>
        ),
      },
    ],
  };
  return (
    <>
      <div className="w-full block whitespace-nowrap overflow-auto">
        <table className="w-full text-center text-black">
          <thead>
            <tr className="border border-[#dddddd]" key={0}>
              {table.header.map((val) => (
                <th
                  className="p-2 bg-[#f2f2f4] border border-[#dddddd]"
                  key={val.id}
                >
                  {val.title}
                </th>
              ))}
            </tr>
          </thead>

          <tbody>
            <tr>
              <td className="p-3 border border-[#dddddd]">
                {data?.requests}건
              </td>
              <td className="p-3 border border-[#dddddd]">{data?.refusal}건</td>
              <td className="p-3 border border-[#dddddd]">
                {data?.completedCreditCard}건
              </td>
              <td className="p-3 border border-[#dddddd]">
                {data?.completedDeposit}건
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </>
  );
}
